import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';

type AgeRange = 'under6' | '7to12' | '13to17' | 'over18';

@Injectable({ providedIn: 'root' })
export class OnboardingService {
  private readonly KEY = 'hasCompletedOnboarding';
  private readonly AGE_RANGE_KEY = 'selectedAgeRange';
  private readonly USER_AGE_KEY = 'userAge';
  private readonly USER_BIRTHDATE_KEY = 'userBirthdate';

  async isComplete(): Promise<boolean> {
    const { value } = await Preferences.get({ key: this.KEY });
    return value === 'true';
  }

  async setComplete(): Promise<void> {
    await Preferences.set({ key: this.KEY, value: 'true' });
  }

  async setAgeRange(ageRange: AgeRange): Promise<void> {
    await Preferences.set({ key: this.AGE_RANGE_KEY, value: ageRange });
  }

  async getAgeRange(): Promise<AgeRange | null> {
    const { value } = await Preferences.get({ key: this.AGE_RANGE_KEY });
    return value as AgeRange | null;
  }

  async setUserAge(age: number): Promise<void> {
    await Preferences.set({ key: this.USER_AGE_KEY, value: age.toString() });
  }

  async getUserAge(): Promise<number | null> {
    const { value } = await Preferences.get({ key: this.USER_AGE_KEY });
    return value ? parseInt(value, 10) : null;
  }

  async setUserBirthdate(birthdate: string): Promise<void> {
    await Preferences.set({ key: this.USER_BIRTHDATE_KEY, value: birthdate });
  }

  async getUserBirthdate(): Promise<string | null> {
    const { value } = await Preferences.get({ key: this.USER_BIRTHDATE_KEY });
    return value;
  }

  async clearUserBirthdate(): Promise<void> {
    await Preferences.remove({ key: this.USER_BIRTHDATE_KEY });
  }
}
